/** 동명이인 구분용 — `이름 (뒤 4자리)` */
export const formatNameWithPhone = (name: string, phone?: string) => {
  const last = (phone ?? '').replace(/\D/g, '').slice(-4);
  return last ? `${name} (${last})` : name;
};
